export default __webpack_public_path__ + "static/update01-8afeff6313f28c25a64eb70af0a85d3f.png";